import React from 'react';

import {
  DiscountPercent,
  OpenBook,
  Packages,
} from '@dutchie/backoffice-ui-library';

import {
  IconTile,
  List,
  ListItem,
  ListItemContent,
  ListItemText,
  ListItemTitle,
  ListTitle,
  SideContentListSection,
} from './styled';
import {
  SideContentBody,
  SideContentBodyText,
  SideContentContainer,
  SideContentHeader,
  SideContentListContainer,
} from './styled';

export const listItems = [
  {
    icon: <Packages />,
    title: 'Rich inventory insights',
    text: 'Connected brands can see item-level metrics like revenue/week, remaining units in stock, days on hand, and days available on menu. Metrics are only available for products sold by that brand.',
  },
  {
    icon: <DiscountPercent />,
    title: '(Coming 2025) Brand-funded promotions',
    text: 'Connected brands can submit proposals for brand-funded discounts, automating the creation, execution, and reporting of deal performance.',
  },
  {
    icon: <OpenBook />,
    title: '(Coming 2025) Brand catalog utilization',
    text: 'Connected brands can view reports on retail utilization of brand catalog names, images, and definitions to help you optimize your content.',
  },
];

export const SideContent = () => {
  return (
    <SideContentContainer>
      <SideContentHeader>
        <span>Connecting with brands</span>
      </SideContentHeader>
      <SideContentBody>
        <SideContentBodyText>
          Connecting with brands enables collaboration through the Dutchie Brand
          Network, offering opportunities to grow your mutual business, simplify
          your shared activities, and streamline communication and business
          planning. We recommend connecting to any brands with which you
          communicate regularly about your joint businesses.
        </SideContentBodyText>
        <SideContentListContainer>
          <SideContentListSection>
            <ListTitle>
              Connect with your trusted brands to facilitate the following
              workflows:
            </ListTitle>
            <List>
              {listItems.map((item) => (
                <ListItem key={item.title}>
                  <IconTile>{item.icon}</IconTile>
                  <ListItemContent>
                    <ListItemTitle>{item.title}</ListItemTitle>
                    <ListItemText>{item.text}</ListItemText>
                  </ListItemContent>
                </ListItem>
              ))}
            </List>
          </SideContentListSection>
        </SideContentListContainer>
      </SideContentBody>
    </SideContentContainer>
  );
};
